export function getPlatform(): 'macos' | 'windows' | 'android' | 'ios' | 'other' {
  const ua = navigator.userAgent || '';

  if (isIOS()) return 'ios'; // iOS ainda não tem download
  if (/Macintosh|MacIntel|MacPPC|Mac68K/.test(ua)) return 'macos';
  if (/Win32|Win64|Windows|WinCE/.test(ua)) return 'windows';
  if (/Android/.test(ua)) return 'android';

  return 'other';
}

export function isIOS(): boolean {
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !('MSStream' in window);
}

export function isIOSWebView(): boolean {
  const ua = window.navigator.userAgent;
  const isSafari = /Safari/.test(ua) && !/CriOS|FxiOS|OPiOS|EdgiOS/.test(ua);

  // "standalone" existe só em iOS Safari
  const standalone = 'standalone' in navigator ? (navigator as any).standalone : false;

  return isIOS() && (!isSafari || !standalone);
}

export function isAndroidWebView(): boolean {
  const ua = navigator.userAgent || '';
  return /Android/.test(ua) && /wv/.test(ua); // 'wv' indica WebView no Android
}

export function isElectron(): boolean {
  const ua = navigator.userAgent || '';
  return /Electron/.test(ua) || !!(window as any).process?.versions?.electron;
}
